const CollapseWhite = () => {
  return (
    <svg
      style={{
        transform: "rotate(90deg)",
        width: "10px",
        height: "auto",
        cursor: "pointer",
      }}
      viewBox="0 0 9 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 1.5L7 9L0 16.5" stroke="#fff" stroke-width="2" />
    </svg>
  );
};
export default CollapseWhite;
